import { Card, CardBody, Col, Table, Button, Container, Row } from "reactstrap";
import TabPlusIcon from "mdi-react/TabPlusIcon";
import DeptListTable from "./CompanyListTable";
import { useHistory } from "react-router";
import { decryption } from "../../../HelperFunctions";
import CompanyListTable from "./CompanyListTable";
import BreadCrumb from "../../../../shared/components/BreadCrumb/BreadCrumb";

const Company = () => {
  const history = useHistory();
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Company ",
    },
  ];
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <BreadCrumb breadCrumbData={breadCrumbData} />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">Company List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {permissions?.includes("create_company") && (
                <Button
                  onClick={() => history.push("/company/new")}
                  color="primary"
                >
                  <TabPlusIcon className="mr-1" />
                  New Company
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <CompanyListTable />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Company;
